/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
/* eslint-disable jsx-a11y/anchor-is-valid  */
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function(value) {
  const [t] = useTranslation();
  const country = process.env.REACT_APP_COUNTRY;
  const excludedCountries = new Set(['hrv', 'srb', 'svn', 'mne']);
  const excludedCountriesForDiverse = new Set(['bih', 'mne']);

  const options = useMemo(() => {
    const baseOptions = [
      { label: t("common.male"), value: "Male", key: "male" },
      { label: t("common.female"), value: "Female", key: "female" }
    ];

    if (!excludedCountriesForDiverse?.has(country)) {
      baseOptions.push({ label: t('common.diverse'), value: 'Unknown', key: 'unknown' });
    }

    if (!excludedCountries?.has(country)) {
      baseOptions.push({ label: t('common.no_information'), value: country === 'rou' ? '1' : 'Null', key: country === 'rou' ? '1' : 'null'  });
    }

    return baseOptions;
  }, [country, t]);


  const valueOption = useMemo(() => [options.find(o => o.value === value)], [value]);

  return [options, valueOption];
}
